﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const form_controls_1 = require("@its-suite/form-controls");
const classnames_1 = require("classnames");
const Utils_1 = require("../../Utils");
const NewPasswordFields_1 = require("./NewPasswordFields");
const PasswordField_1 = require("./PasswordField");
const styles = require("./UpdatePasswordFields.scss");
exports.updatePasswordFieldsId = Utils_1.PrefixId.UpdatePasswordFields;
class UpdatePasswordFields extends React.Component {
    constructor(props) {
        super(props);
        this.getCurrentPasswordField = (inputStyles, validator) => {
            return (React.createElement("div", null,
                React.createElement(PasswordField_1.PasswordField, { prefixId: exports.updatePasswordFieldsId, name: form_controls_1.StringHelpers.nameof('currentPassword'), value: this.props.currentPasswordValue, label: this.props.texts.currentPassword, onChange: this.props.onChange, onFocus: this.props.onFocus, autoComplete: 'current-password', className: classnames_1.default(inputStyles, styles.w100), validators: this.props.isEnabled && [validator], disabled: !this.props.isEnabled })));
        };
        this.getNewPasswordFields = (containerStyles, inputStyles) => {
            return (React.createElement(NewPasswordFields_1.NewPasswordFields, { onChange: this.props.onChange, onFocus: this.props.onFocus, passwordValue: this.props.passwordValue, confirmationPasswordValue: this.props.passwordConfirmationValue, className: classnames_1.default(inputStyles), renderOuterDivs: true, outerDivsClassName: classnames_1.default(styles.inputContainer, ...containerStyles), disabled: !this.props.isEnabled, prefixId: exports.updatePasswordFieldsId, userName: this.props.username, texts: this.props.texts }));
        };
        this.state = {
            passwordErrorMessage: ''
        };
    }
    render() {
        var _a, _b;
        let requiredValidator = new form_controls_1.Validator({ validatorType: form_controls_1.ValidatorTypes.Required, message: this.props.texts.requiredFieldError });
        const inputsClassnames = (_a = this.props.inputsClassName) !== null && _a !== void 0 ? _a : [];
        const inputsContainersClassnames = (_b = this.props.inputsContainerClassName) !== null && _b !== void 0 ? _b : [];
        return (React.createElement(React.Fragment, null,
            this.getCurrentPasswordField(inputsClassnames, requiredValidator),
            this.getNewPasswordFields(inputsContainersClassnames, inputsClassnames)));
    }
}
exports.UpdatePasswordFields = UpdatePasswordFields;
//# sourceMappingURL=UpdatePasswordFields.js.map